exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filter-checkbox{margin-right:8px;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:0;height:20px;width:20px;min-width:20px;border:2px solid gray;border-radius:3px;color:#000;position:relative;top:1px}.filter-checkbox:checked{color:#000}.filter-checkbox::after{content:\" \";position:relative;top:1px;left:6px;width:5px;height:10px;border:solid #000;border-width:0 2px 2px 0;transform:rotate(45deg);display:none}.filter-checkbox:checked::after{display:block}.highlighted-text{color:#2a2a2a}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};